<template>
  <div class="ticketing-steps bg-white border-bottom">
    <div class="container">
      <div class="row">
        <div class="col ticketing-step" v-for="(stepInfo, index) in steps" :key="index">
          <div :class="{ 'text-danger': step === index + 1 }">
            <i :class="stepInfo.icon"></i>
            <span>{{ stepInfo.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  step: {
    type: Number,
    required: true
  }
})

const steps = [
  { icon: 'fe fe-grid', text: 'Chọn số lượng' },
  { icon: 'fe fe-credit-card', text: 'Thanh toán' },
  { icon: 'fe fe-inbox', text: 'Thông tin voucher' }
]
</script>
